import { render, staticRenderFns } from "./ParagraphPreview.vue?vue&type=template&id=55e4719d&scoped=true&"
import script from "./ParagraphPreview.vue?vue&type=script&lang=js&"
export * from "./ParagraphPreview.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphPreview.vue?vue&type=style&index=0&id=55e4719d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4719d",
  null
  
)

export default component.exports